import React, { useState,useEffect } from 'react';
import {
    Input,Button,Layout,
    Row,Col,
    Form,
    DatePicker,
    Select,Steps,
    Card,Collapse,
    Checkbox,
    Tooltip
} from 'antd';
import {
    SearchOutlined,
    EnvironmentOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import NextModel from './Next_Model';
import { useDispatch } from 'react-redux';
import {
    GetSoilProfileToPerformed,
    GetPropertiesToPerformed,
    getUserList,
    fetchSoilProfileList,
    AddNewTemplate
} from '@/util/Request';
import {AnalysisDelete} from '@/resource/IconComponentSets';
import emptyTemplate from '@/resource/icon-png/emptyTemplate.png';
const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;
const { Step } = Steps;
const { Meta } = Card;
const { Panel } = Collapse;
import TemplateGoogleMap from '@/components/TemplateGoogleMap';
import './index.less';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
function Collapsecallback(key){
    console.log(key);
}
const SoilAnalyses = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [stepsKey,setStepsKey] = useState<number>(0);
    const [nextOption,setNextOption] = useState([] as any);
    const [propertyMeasurmentIdInfo,setPropertyMeasurmentIdInfo] = useState([] as any);
    const [user,setUser] = useState([] as any);
    const [options,setOptions] = useState(<></> as React.ReactNode);
    const [countriesString,setCountriesString] = useState('');
    const [mark,setMark] = useState([] as any);
    const [selectIds,setSelectIds] = useState([] as any);
    const [update,setUpdate] = useState(false);
    const [cardLng,setCardLng] = useState([]);
    const [defaultCenter,setDefaultCenter] = useState(null);
    const [ajaxLayer,setAjaxLayer] = useState([]);
    const [layerMap,setLayerMap] = useState(new Map());
    const [layerMapSelectId,setLayerMapSelectId] = useState(new Map());
    const [layerInfo,setLayerInfo] = useState('');
    useEffect(() => {
        GetAnalyses();
    }, []);
    const GetAnalyses = async ()=>{
        const res3 = await GetPropertiesToPerformed({});
        setNextOption(res3);
        const res1 = await getUserList({isGetAllUsers: true});
        getChart();
        setUser(res1);
        const option = res1.map((obj)=>{
            return <Option value={obj.userId} key={obj.userId}>{obj.userDisplayName}</Option>;
        });
        setOptions(option);
        setUpdateKey(!updataKey);
    };
    const getChart = async ()=>{
        const requestParam = {
            isMy: false,
            searchString: countriesString,
        };
        const allProfileDataRequstData = {
            order: 'DESC',
            sortCol: 'code',
            pageIndex: 1,
            pageSize: 10000,
            searchString: countriesString,
        };

        const res4 = await fetchSoilProfileList(allProfileDataRequstData);
        console.log(res4);
        setMark(res4);
    };
    const onSearch = value =>{
        setCountriesString(value);
    };
    useEffect(() => {
        getChart();
    }, [countriesString]);
    useEffect(()=>{
        const element1 = document.querySelector('.sidebar') as HTMLElement;
        element1.style.height = 'auto';
        return()=>{
            element1.style.height = '100%';
        };
    },[]);
    const addStep = ()=>{
        if(stepsKey==0){
            const arr = [];
            selectIds.map(obj=>{
                const arry = layerMap.get(obj);
                if(arry?.length>0){
                    arry.map(item=>{
                        if(layerMapSelectId.get(item.layerId)){
                            arr.push(item.layerId);
                        }
                    });
                }
            });
            console.log(arr);
            if(arr.length>0){
                setLayerInfo(arr.join('^'));
                setStepsKey(stepsKey+1);
            }else{
                dispatch(updateWarningMessage('Layer is required !'));
            }
        }
        if(stepsKey==1){
            let bas = false;
            isRequire.map(obj=>{
                if(obj == ''){
                    bas = true;
                }
            });
            if(isRequire.length == 0) bas = true;
            if(bas){
                dispatch(updateWarningMessage('Soil Properties and Estimation Method is required !'));
            }else{
                console.log(propertyMeasurmentIdInfo,isRequire);
                const newArr = [...new Set(isRequire)];
                if(newArr.length<isRequire.length){
                    dispatch(updateWarningMessage('Soil Properties must be different !'));
                }else{
                    console.log(layerInfo);
                    setStepsKey(stepsKey+1);
                }
            }
        }
    };
    const AllSubmit = ()=>{
        form.validateFields().then(async values=>{
            let ax = propertyMeasurmentIdInfo;
            if(typeof propertyMeasurmentIdInfo !='string'){
                if(propertyMeasurmentIdInfo.length==0){
                    return dispatch(updateWarningMessage('Soil Properties and Estimation Method is required !'));
                }
                ax = propertyMeasurmentIdInfo.join('^');
            }
            const submitData = Object.assign(
                values,
                {
                    layerIdInfo:layerInfo,
                    propertyMeasurmentIdInfo:ax,
                    samplingDate:moment(values.samplingDate).format('YYYY-MM-DD'),
                    successFlag:0,
                    templateDesc:''
                }
            );
            try{
                dispatch({type:'common/updateShowLoading',payload:true});
                await AddNewTemplate(submitData);
                dispatch({type:'common/updateShowLoading',payload:false});
                dispatch(updateSuccessMessage('New Template added successfully!'));
                setTimeout(e=>{
                    navigate(-1);
                },800);
            } catch(e){
                dispatch({type:'common/updateShowLoading',payload:false});
                dispatch(updateWarningMessage('The server is not working!'));
            }
            console.log(submitData);
        }).catch(err=>{
            console.log(err);
        });
    };
    const resStep = ()=>{
        setStepsKey(stepsKey-1);
    };
    let nex = 1;
    const [isRequire,setIsRequire] = useState([]);
    const submitTableData = (data)=>{
        if(nex==1){
            nex++;
            const param = data.dataSource.map(e=>e.methodID);
            setPropertyMeasurmentIdInfo(param.join('^'));
            console.log(param);
            setIsRequire(param);
            setTimeout(e=>{
                nex=1;
            },200);
        }

    };
    const addMarksCallBack = async (param,isSelect)=>{
        if(isSelect){
            console.log(param);
            const num = selectIds.filter(e=>e == param.id);
            const arr = selectIds;
            if(num.length==0&&isSelect){
                arr.push(param.id);
                setCardLng([...cardLng,param]);
                setSelectIds(arr);
            }
            console.log(arr);
            setUpdate(!update);
            const res = await GetSoilProfileToPerformed({
                userid:'',
                profileid:param.id
            });
            layerMap.set(param.id,res);
            res.map(obj=>{
                setLayerMapSelectId(layerMapSelectId.set(obj.layerId,false));
            });
            setLayerMap(layerMap);
            console.log(layerMapSelectId);
            setAjaxLayer(res);
        }else{
            const res = await GetSoilProfileToPerformed({
                userid:'',
                profileid:param.id
            });
            setAjaxLayer(res);
            setUpdate(!update);
        }
    };
    const lngClick = (lng:any)=>{
        console.log(lng);
        setDefaultCenter({
            lat:lng.lat,
            lng:lng.lng
        });
        setUpdate(!update);
    };
    const lngDelete = (lng:any)=>{
        console.log(lng,selectIds,cardLng);
        console.log(layerMap,layerMapSelectId,cardLng,selectIds);
        setSelectIds(selectIds.filter(e=>e!=lng.id));
        setCardLng(cardLng.filter(e=>e.id!=lng.id));
        layerMap.delete(lng.id);
        setLayerMap(layerMap);
    };
    const [updataKey,setUpdateKey] = useState(false);

    const [tooltipVisible,setTooltipVisible] = useState(false);
    const [tooltipText,setTooltipText] = useState('');
    const testIsRequired = ()=>{
        if(stepsKey==0){
            const arr = [];
            selectIds.map(obj=>{
                const arry = layerMap.get(obj);
                if(arry?.length>0){
                    arry.map(item=>{
                        if(layerMapSelectId.get(item.layerId)){
                            arr.push(item.layerId);
                        }
                    });
                }
            });
            if(arr.length==0){
                setTooltipText('Select Soil Profile to continue. Tap on green pin on a map to select ');
                setTooltipVisible(true);
                return;
            }
        }
        if(stepsKey==1){
            let bas = false;
            isRequire.map(obj=>{
                if(obj == ''){
                    bas = true;
                }
            });
            if(isRequire.length == 0) bas = true;
            if(bas){
                setTooltipText('Soil Properties and Estimation Method is required !');
                setTooltipVisible(true);
            }else{
                const newArr = [...new Set(isRequire)];
                if(newArr.length<isRequire.length){
                    setTooltipText('Estimation Method Must be different !');
                    setTooltipVisible(true);
                }
            }
        }
    };

    return (
        <div className="test newTemplate" style={{padding:10}}>
            <Content style={{ backgroundColor: '#fff' }}>
                <Row gutter={20}>
                    <Col span={8}>
                        <h2 className="soliHeader" style={{paddingLeft:0,marginBottom:16}}>New Template</h2>
                        {stepsKey==0&&<h4 className="soliHeader" style={{paddingLeft:0,fontSize:'16px',marginBottom:19}}>Soil Profile</h4>}
                        {stepsKey==1&&<h4 className="soliHeader" style={{paddingLeft:0,fontSize:'16px',marginBottom:19}}>Soil Properties</h4>}

                        {
                            stepsKey==0&&<div>
                                <Search
                                    placeholder="Search"
                                    allowClear
                                    enterButton="Search"
                                    prefix={<SearchOutlined style={{color:'#696F88'}}/>}
                                    onSearch={onSearch}
                                    style={{width:'95%'}}
                                />
                                <h5 style={{fontSize:'14px'}}>Input profile name, ID or location</h5>
                                {
                                    (()=>{
                                        if(cardLng.length==0){
                                            return (
                                                <div style={{textAlign:'center',margin:'56px auto'}}>
                                                    <p style={{fontWeight:600,fontSize:16,color:'#00004B'}}>Your template has no Soil Profile yet</p>
                                                    <img src={emptyTemplate} alt="" />
                                                    <p style={{fontWeight:400,fontSize:14,color:'#4D5165'}}>Search Soil Profile on a map</p>
                                                    <p style={{fontWeight:400,fontSize:14,color:'#4D5165'}}>and tap on pin to select</p>
                                                </div>
                                            );
                                        }else{
                                            return (
                                                <h4 style={{fontSize:12,fontWeight:600,margin:'37px 0 16px 0'}}>MY SOIL PROFILE </h4>
                                            );
                                        }
                                    })()
                                }
                                {
                                    cardLng.length>0&&<div style={{height:'calc(100vh - 310px)',overflow:'auto'}}>
                                        {
                                            cardLng.map(obj=>{
                                                return (
                                                    // <>
                                                    <Card
                                                        key={obj.id}
                                                        size="small"
                                                        style={{position:'relative',marginBottom:10}}
                                                    >
                                                        <Meta style={{}}
                                                            description={obj.code }
                                                            title= {obj.name}
                                                        />
                                                        <div style={{position:'absolute',right:10,top:15,display:'flex'}}>
                                                            <EnvironmentOutlined onClick={()=>lngClick(obj)} style={{marginTop:2}}/>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                                            <AnalysisDelete onClick={()=>lngDelete(obj)} />
                                                        </div>
                                                        <Collapse
                                                            defaultActiveKey={['1']}
                                                            onChange={Collapsecallback}
                                                            expandIconPosition={'right'}
                                                            collapsible='header'
                                                        >
                                                            <Panel
                                                                header={'Soil Layers'}
                                                                key='1'
                                                                extra={
                                                                    <Checkbox
                                                                        checked={(()=>{
                                                                            let bar = true;
                                                                            (layerMap.get(obj.id)!=undefined&&layerMap.get(obj.id).length>0)&&layerMap.get(obj.id).map(item=>{
                                                                                if(!layerMapSelectId.get(item.layerId)) bar = false;
                                                                            });
                                                                            return bar;
                                                                        })()}
                                                                        onChange={event => {
                                                                            (layerMap.get(obj.id)!=undefined&&layerMap.get(obj.id).length>0)&&layerMap.get(obj.id).map(item=>{
                                                                                setLayerMapSelectId(layerMapSelectId.set(item.layerId,event.target.checked));
                                                                            });
                                                                            setUpdateKey(!updataKey);
                                                                            event.stopPropagation();
                                                                        }}
                                                                    ></Checkbox>
                                                                }>
                                                                <div>
                                                                    {
                                                                        (layerMap.get(obj.id)!=undefined&&layerMap.get(obj.id).length>0)&&layerMap.get(obj.id).map((ob,ix)=>{
                                                                            return (
                                                                                <Row key={ob.layerId} className='fathers' style={{height:ix==0?'25px':'40px'}}>
                                                                                    <Col span={21} style={{top:ix==0?'12px':'27px'}} className='sun1'>
                                                                                        {ob.layerRank} | {ob.thickness.replace(/,/g,'-')} cm
                                                                                    </Col>
                                                                                    <Col span={3} style={{top:ix==0?'12px':'27px',textAlign:'right'}} className='sun2'>
                                                                                        <Checkbox checked={layerMapSelectId.get(ob.layerId)}
                                                                                            onChange={event => {
                                                                                                setLayerMapSelectId(layerMapSelectId.set(ob.layerId,event.target.checked));
                                                                                                setUpdateKey(!updataKey);
                                                                                            }}
                                                                                        ></Checkbox>
                                                                                    </Col>
                                                                                </Row>
                                                                            );
                                                                        })
                                                                    }
                                                                </div>
                                                            </Panel>
                                                        </Collapse>
                                                    </Card>
                                                    // </>
                                                );
                                            })
                                        }
                                        {
                                            stepsKey==0&&<footer className='bottomBottons' style={{padding:'10px'}}>
                                                <Button type="text" shape="round" >
                                                    <Link to="/templateUpdate">Cancel</Link>
                                                </Button>
                                                <Tooltip open={tooltipVisible} placement="bottomRight" title={tooltipText}>
                                                    <Button type="primary" shape="round" onClick={addStep}
                                                        onMouseOver={testIsRequired}
                                                        onMouseLeave={()=>setTooltipVisible(false)}
                                                    >Next</Button>
                                                </Tooltip>
                                            </footer>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {
                            cardLng.length==0&&stepsKey==0&&<footer className='bottomBottons' style={{padding:'10px'}}>
                                <Button type="text" shape="round" >
                                    <Link to="/templateUpdate">Cancel</Link>
                                </Button>
                                <Tooltip open={tooltipVisible} placement="bottomRight" title={tooltipText}>
                                    <Button type="primary" shape="round" onClick={addStep}
                                        onMouseOver={testIsRequired}
                                        onMouseLeave={()=>setTooltipVisible(false)}
                                    >Next</Button>
                                </Tooltip>
                            </footer>
                        }
                        {
                            stepsKey==2&&<div>
                                <h4 className="soliHeader" style={{fontSize:'16px',marginBottom:'20px',padding:0}}>Finish</h4>
                                <Form name="nest-messages" layout="vertical" form={form}>
                                    <Form.Item name="templateName" label="Template Name" rules={[{ required: true,message:'Template Name is Required!' }]}>
                                        <Input placeholder='Template Name'/>
                                    </Form.Item>
                                    <Form.Item label="Sample Requested by" name="requestedBy" rules={[{ required: true,message:'Sample Requested by is Required!' }]}>
                                        {/* <Select placeholder="Select">
                                            {options}
                                        </Select> */}
                                        <Select
                                            placeholder="Select"
                                            showSearch
                                            filterOption={(input, option) => (option!.children?.toString()?.toLowerCase() as unknown as string).includes(input?.toLowerCase())}
                                            size="middle">
                                            {options}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="Sampling Date" name="samplingDate" rules={[{ required: true,message:'Sampling Date is Required!' }]}>
                                        <DatePicker
                                            style={{width:'100%'}} placeholder="Select date" format="DD-MM-YYYY"/>
                                    </Form.Item>
                                    <Form.Item label="Sample Taken by" name="sampleTekenBy">
                                        {/* <Select placeholder="Select">
                                            {options}
                                        </Select> */}
                                        <Select
                                            placeholder="Select"
                                            showSearch
                                            filterOption={(input, option) => (option!.children?.toString()?.toLowerCase() as unknown as string).includes(input?.toLowerCase())}
                                            size="middle">
                                            {options}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label="Sample Analyzed by" name="sampleAnalyzedBy">
                                        {/* <Select placeholder="Select">
                                            {options}
                                        </Select> */}
                                        <Select
                                            placeholder="Select"
                                            showSearch
                                            filterOption={(input, option) => (option!.children?.toString()?.toLowerCase() as unknown as string).includes(input?.toLowerCase())}
                                            size="middle">
                                            {options}
                                        </Select>
                                    </Form.Item>
                                </Form>
                                <footer className='bottomBottons'>
                                    <Button
                                        type="text" shape="round" onClick={resStep}>Back</Button>
                                    <Button
                                        type="primary"
                                        shape="round" onClick={AllSubmit}>Finish</Button>
                                </footer>
                            </div>
                        }
                    </Col>
                    <Col span={16} style={{padding:'0 20px'}}>
                        <Col span={24} style={{paddingBottom:'10px'}}>
                            <div className="soliHeader">
                                <Steps size="small" current={stepsKey}>
                                    <Step title="Soil Profile" />
                                    <Step title="Soil Properties" />
                                    <Step title="Finish" />
                                </Steps>
                            </div>
                        </Col>
                        <Col span={24}>
                            {stepsKey!=1&&<TemplateGoogleMap marks={mark} addMarksCallBack={addMarksCallBack} selectId={selectIds} isNew={update} defaultCenter={defaultCenter} layer={ajaxLayer}/>}
                        </Col>
                    </Col>
                    <Col span={24} style={{display:stepsKey==1?'block':'none'}}>
                        <NextModel
                            saveTable={submitTableData}
                            Table={undefined}
                            editOption={nextOption}
                            visible={updataKey}
                            editParam={null}
                            disabled={false}
                        />
                    </Col>
                </Row>
            </Content>
            {
                stepsKey==1&&<div className='bottomBotton2'>
                    <Button type="text" shape="round" onClick={resStep}>Back</Button>
                    <Tooltip open={tooltipVisible} placement="bottomRight" title={tooltipText}>
                        <Button type="primary" shape="round" onClick={addStep}
                            onMouseOver={testIsRequired}
                            onMouseLeave={()=>setTooltipVisible(false)}
                        >Next</Button>
                    </Tooltip>
                </div>
            }
        </div>
    );
};
export default SoilAnalyses;
